import React from "react";

export default function CautionIcon() {
  return <span className="ab-icon">⚠️</span>;
}
